<template>
  <div id="header-search">
    <span class="header-search-label">
      <i class="icon-search icon"></i>
    </span>

    <select id="searchType" v-model="searchType">
      <option value="tagLine">Par tag</option>
      <option value="fullTextLine">Full text</option>
      <option value="q">Web</option>
    </select>

    <div v-if="searchType == 'tagLine'">
      <TagsInput id="tags" v-model="tags" :availableTags="queryTags" :noCreation="true"></TagsInput>
    </div>
    <div v-if="searchType == 'fullTextLine'">
      <label for="fulltext" :title='$t(`ex: dad or mum -"little children"`)'>fulltext</label>
      <input id="fulltext" type="text" v-model="fulltext" @keyup.enter="searchFulltext(mFulltext)" />
    </div>
    <form  v-if="searchType == 'q'" :action="$fetch.createUrl('/opensearch')">
      <label for="web">web</label>
      <input id="web" name="action" type="text" />
    </form>

    <Button @click="search" class="button">Search</Button>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Button from '@/components/common/Button.vue'
import TagsInput from '@/components/common/TagsInput'

@Component({
  name: 'HeaderSearchInput',
  components: {
    Button,
    TagsInput
  }
})
class SearchInput extends Vue {
  // mTags = ''
  mFulltext = ''
  timeoutFulltextSearch = 0
  searchType = 'tagLine';

  cancelTimeoutFulltextSearch() {
    this.timeoutFulltextSearch && clearTimeout(this.timeoutFulltextSearch)
    this.timeoutFulltextSearch = 0
  }

  search() {
    switch(this.searchType) {
      case 'tagLine':
        alert('toDo');
        break;
      case 'fulltext':
        this.searchFulltext(this.mFulltext);
        break;
      case 'q':
        alert('toDo');
        break;
    }
  }

  searchFulltext(value) {
    this.cancelTimeoutFulltextSearch()
    this.changeFulltextAndGo(value)
  }

  get tags() {
    const tags = this.queryInfo.tags
    if (!tags) {
      return []
    }

    return Array.isArray(tags) ? tags : [tags]
  }

  set tags(newTags) {
    this.changeTagsAndGo(newTags)
  }

  get fulltext() {
    return this.queryInfo.fulltext
  }

  set fulltext(value) {
    this.mFulltext = value
    this.cancelTimeoutFulltextSearch()
    this.timeoutFulltextSearch = setTimeout(
      function(ft) {
        this.searchFulltext(ft)
      }.bind(this),
      1000,
      value
    )
  }

}

export default SearchInput
</script>

<style scoped lang="less">
#header-search {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-top: 0;
  padding-bottom: 0;


  & > * {
    margin: var(--margin--small);
  }
}

.button {
  height: var(--default-ui-element-height);
  font-size: 13px;
}
</style>
